import {
  Box,
  Button,
  Collapse,
  Modal,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { CustomerDatabaseStore } from "../../../../../store/main/CustomerDatabaseStore";
import { useEffect } from "react";
import { DailyPOBReportStore } from "../../../../../store/main/DailyPOBReportStore";
import { FetchState } from "../../../../../domain/models/fetch-state";
import DailyPOBReportModalLoading from "../../DailyPOBReportModalLoading";
import { Typography } from "antd";
import { ReportFiltersComponentStore } from "../../../../../store/main/ReportFilterComponentStore";

type props = {
  open: boolean;
  setOpen: Function;
  day: number;
  userId: number;
  year: number;
  month: number;
  departmentId: string | null;
  name: string;
  customerTypeId: string | null;
};
const VisitDataModal: React.FC<props> = ({
  open,
  setOpen,
  day,
  userId,
  month,
  year,
  departmentId,
  name,
  customerTypeId,
}) => {
  const EditCustomerModalStyle = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "60%",
    bgcolor: "background.paper",
    borderRadius: "24px",
    boxShadow: 24,
  };

  const {
    DayWiseCustomerPOBData,
    DayWiseCustomerPOBDataState,
    fetchDayWiseCustomerPOBData,
  } = DailyPOBReportStore();

  const { decodeToken } = CustomerDatabaseStore();

    const {
      fetchReportFiltersComponent,
      resetReportFiltersComponent,
      reportFiltersComponent,
    } = ReportFiltersComponentStore();

  const monthString = month.toString().padStart(2, "0");

  useEffect(() => {
    decodeToken();

    let params = {
      user_id: userId,
      day: day,
      month: monthString,
      year: year,
      department_id: departmentId,
      customer_type_id: customerTypeId,
      brand_ids: reportFiltersComponent.brandType,
    };

    fetchDayWiseCustomerPOBData(params);
  }, []);

  const formattedDay = day < 10 ? `0${day}` : day;
  const formattedMonth = month < 10 ? `0${month}` : month;

  return (
    <>
      <Modal open={open}>
        <Box sx={EditCustomerModalStyle}>
          <Stack alignItems={"center"} justifyContent={"center"} spacing={1}>
            <Paper
              sx={{
                width: "100%",
                overflow: "hidden",
                padding: "3%",
                borderRadius: "24px",
              }}
            >
              {DayWiseCustomerPOBDataState === FetchState.LOADING && (
                <Stack
                  justifyContent="center"
                  alignItems="center"
                  height="60vh"
                >
                  <DailyPOBReportModalLoading />
                </Stack>
              )}
              <Typography
                style={{
                  fontWeight: "bolder",
                  fontSize: "18px",
                  textAlign: "left",
                  marginBottom: "1%",
                }}
              >
                Order on ({formattedDay}/{formattedMonth}/{year}) for {name}
              </Typography>
              {DayWiseCustomerPOBDataState === FetchState.SUCCESS && (
                <TableContainer sx={{ maxHeight: "60vh" }}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        {[
                          "Id",
                          "Customer",
                          "Type",
                          "Brick Name",
                          "Total Amount",
                          "Delivered By",
                        ].map((header) => (
                          <TableCell
                            key={header}
                            align="center"
                            sx={{
                              backgroundColor: "#f9fafd",
                              color: "#687182",
                            }}
                          >
                            {header}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {DayWiseCustomerPOBData.UserOrdersPOB &&
                      DayWiseCustomerPOBData.UserOrdersPOB.length > 0 ? (
                        DayWiseCustomerPOBData.UserOrdersPOB.map((detail) => (
                          <TableRow key={detail.id}>
                            <TableCell align="center">
                              {detail.id ?? "-"}
                            </TableCell>
                            <TableCell align="center">
                              {detail.firm_name ?? "-"}
                            </TableCell>
                            <TableCell align="center">
                              {detail.Type ?? "-"}
                            </TableCell>
                            <TableCell align="center">
                              {detail.Brick_name ?? "-"}
                            </TableCell>
                            <TableCell align="center">
                              {parseFloat(detail.Total_Amount).toFixed(2) ??
                                "-"}
                            </TableCell>
                            <TableCell align="center">
                              {detail.Delivered_by ?? "-"}
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell
                            colSpan={6}
                            sx={{
                              textAlign: "center",
                              padding: 2,
                              fontWeight: "bold",
                              fontSize: "1.2rem",
                            }}
                          >
                            No data available
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
              <Button
                variant="contained"
                onClick={() => setOpen(false)}
                sx={{
                  alignItems: "center",
                  marginX: "auto",
                  marginTop: "10px",
                  justifyContent: "center",
                  display: "flex",
                }}
              >
                Close
              </Button>
            </Paper>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};

export default VisitDataModal;
